import type * as UpdateDelivery from '@ori-events/update-delivery';
import type { Data as ErrorData, UpdateDeliveryResponse } from '@ori-events/update-delivery-failed';
import {
  isUpdateDeliveryErrorResponse,
  Name as ErrorEventName,
} from '@ori-events/update-delivery-failed';

import { convertToCamelCase } from '../helpers';
import { RequestUrl } from '../models';
import { putRequestOptions } from '~/constants';

type Data = UpdateDelivery.Data;

export default async ({
  detail: { deliveryAddressId, deliveryChannelId, registrationId },
}: CustomEvent<Data>) => {
  // if needed, start with delivery channel ID update
  if (typeof deliveryChannelId !== 'undefined') {
    const channelRequestOptions = {
      ...putRequestOptions,
      body: JSON.stringify({ deliveryChannelId }),
    };
    const requestUpdateDeliveryChannel = await fetch(
      RequestUrl.UpdateDeliveryChannel,
      channelRequestOptions,
    );

    const channelResponse = convertToCamelCase<UpdateDeliveryResponse>(
      (await requestUpdateDeliveryChannel.json()) as object,
    );

    if (isUpdateDeliveryErrorResponse(channelResponse)) {
      const errorEvent = new CustomEvent<ErrorData>(ErrorEventName, {
        detail: channelResponse,
      });
      window.dispatchEvent(errorEvent);

      return false;
    }
  }

  // delivery address ID update
  const addressParams: {
    addressId: number;
    registrationId?: string;
  } = {
    addressId: deliveryAddressId,
  };
  if (registrationId) {
    addressParams.registrationId = registrationId;
  }
  const addressRequestOptions = {
    ...putRequestOptions,
    body: JSON.stringify(addressParams),
  };
  const requestUpdateDeliveryAddress = await fetch(
    RequestUrl.UpdateDeliveryAddress,
    addressRequestOptions,
  );

  const addressResponse = convertToCamelCase<UpdateDeliveryResponse>(
    (await requestUpdateDeliveryAddress.json()) as object,
  );

  if (isUpdateDeliveryErrorResponse(addressResponse)) {
    const errorEvent = new CustomEvent<ErrorData>(ErrorEventName, {
      detail: addressResponse,
    });
    window.dispatchEvent(errorEvent);

    return false;
  }

  return addressResponse;
};
